import cn from "classnames";
import React from "react";

const ContentBox = ({children, className}) => {
    let boxClassName = cn(['', 'content-box'], className);

    return (
        <div className="container-100">
            <div className="content-box-container contained-width">

                <div className={boxClassName}>
                    <div className="block">
                        <img src="/logo.png" height="80" />
                    </div>

                    {children}
                </div>
            </div>
        </div>
    );
};

export default ContentBox;